export const messages = {
  fr: {
    app: {
      loading: 'Préparation de votre espace',
      language: 'Langue',
      french: 'Français',
      english: 'English',
    },
    common: {
      close: 'Fermer',
      cancel: 'Annuler',
      save: 'Enregistrer',
      send: 'Envoyer',
      loading: 'Chargement…',
      sending: 'Envoi…',
      notSpecified: 'Non renseigné',
      notDefined: 'Non défini',
      client: 'Client',
      professional: 'Artisan',
      member: 'Membre',
      project: 'Projet',
      projects: 'Projets',
      photo: 'photo',
      photos: 'photos',
      new: 'Nouveau',
      view: 'Voir',
      edit: 'Modifier',
      delete: 'Supprimer',
      previous: 'Précédent',
      next: 'Suivant',
      day: 'jour',
      days: 'jours',
      all: 'Toutes',
      update: 'Mettre à jour',
      confirm: 'Confirmer',
      validating: 'Validation…',
      withdrawing: 'Retrait…',
      noMessage: 'Aucun message fourni.',
      euro: '€',
    },
    nav: {
      clientDemands: 'Mes demandes',
      history: 'Historique',
      profile: 'Mon profil',
      logout: 'Déconnexion',
      missions: 'Mes missions',
      planning: 'Mon planning',
      explore: 'Explorer',
      showcase: 'Vitrine',
      verifyEmail: 'Vérifier mon e-mail',
      login: 'Connexion',
      signup: 'Inscription',
      mobileDemands: 'Demandes',
      mobileMissions: 'Missions',
      mobilePlanning: 'Planning',
      mobileProfile: 'Profil',
    },
    notifications: {
      title: 'Notifications',
      empty: 'Vous êtes à jour.',
      markAll: 'Tout marquer comme lu',
      close: 'Fermer les notifications',
      unread: '{{count}} non lue(s)',
    },
    jobs: {
      pageTitle: 'Vos offres et chantiers',
      workspaceTitle: 'Votre espace de travail',
      workspaceEyebrow: 'Pilotage des missions',
      workspaceSubtitle: 'Retrouvez les actions utiles, les devis et les chantiers actifs sans perdre le fil.',
      summaryAria: '{{projects}} projets suivis et {{offers}} propositions en attente',
      summaryOffers: 'propositions',
      summaryActions: 'actions',
      summaryActive: 'en cours',
      summaryFinalize: 'à finaliser',
      planVisits: 'Planifier mes visites',
      tabsAria: 'Catégories de missions',
      searchPlaceholder: 'Client, chantier, adresse…',
      searchAria: 'Rechercher une mission',
      sortAria: 'Trier les missions',
      sortPriority: 'Priorité',
      sortNewest: 'Plus récentes',
      sortOldest: 'Plus anciennes',
      sortAmount: 'Montant du devis',
      noResults: 'Aucun résultat',
      noTabJobs: 'Aucune mission dans « {{tab}} »',
      tryAnotherKeyword: 'Essayez un autre mot-clé.',
      attention: 'Action requise',
      projectBy: 'Projet de',
      viewClientProfile: 'Voir le profil client',
      viewScore: 'Voir le score',
      clientProfile: 'profil client',
      verifiedProjects: '{{count}} projet(s)',
      noDescription: 'Aucune description fournie.',
      progress: 'Avancement du projet',
      step: 'Étape {{step}} sur 8',
      published: 'Demande publiée',
      visitPlanned: 'Visite prévue',
      quoteAmount: 'Montant du devis',
      clientContact: 'Contact client',
      visitConfirmedWaitingClient: 'Votre présence est confirmée. Le client doit maintenant confirmer que la visite a bien eu lieu.',
      visitConfirmInstruction: 'Après la visite, confirmez votre présence. Le client pourra ensuite confirmer à son tour.',
      moreInfoInstruction: 'Échangez avec le client ci-dessous. Lorsque vous disposez des informations nécessaires, ouvrez la préparation du devis.',
      issuePrefix: 'Le client a signalé un problème :',
      issueFallback: 'consultez la conversation et convenez d’une solution.',
      confirmVisit: 'Confirmer la visite effectuée',
      infoReady: 'J’ai les informations nécessaires',
      prepareQuote: 'Préparer le devis',
      reviseQuote: 'Réviser le devis',
      issueResolved: 'Correction effectuée, redemander confirmation',
      declareFinished: 'Déclarer les travaux terminés',
      reviewClient: 'Évaluer le client',
      viewQuote: 'Voir le devis',
      withdrawOffer: 'Retirer mon offre',
      showMore: 'Afficher {{count}} mission(s) supplémentaire(s)',
      photoAlt: 'Photos du chantier {{type}}',
      portfolioPublished: 'Publié dans la vitrine',
      portfolioDraft: 'Brouillon',
      portfolioHidden: 'Masqué',
      portfolioMissing: 'Non ajouté',
      portfolioAdd: 'Ajouter à ma vitrine',
      portfolioEdit: 'Modifier la vitrine',
      completedProject: 'Projet terminé',
      viewReview: 'Consulter l’avis',
      viewFile: 'Voir le dossier',
      archiveAlt: 'Projet {{title}}',
      tabOffers: 'Propositions',
      tabOffersDescription: 'Les propositions envoyées avant attribution définitive du projet.',
      tabAction: 'À traiter',
      tabActionDescription: 'Les missions qui attendent une action de votre part.',
      tabActive: 'En cours',
      tabActiveDescription: 'Vos propositions, devis envoyés et chantiers actifs.',
      tabFinalize: 'À finaliser',
      tabFinalizeDescription: 'Les projets en attente de paiement ou d’avis client.',
      tabCompleted: 'Terminées',
      tabCompletedDescription: 'Vos anciens projets, archivés et disponibles pour votre vitrine.',
      status: {
        estimation_wait: { label: 'Proposition envoyée', description: 'Le client étudie votre proposition de visite.' },
        estimation_confirmed: { label: 'Visite acceptée', description: 'Prenez contact avec le client et préparez la visite.' },
        estimation_visit_valid: { label: 'Devis à préparer', description: 'La visite est validée. Le client attend votre devis détaillé.' },
        contract_offered: { label: 'Devis envoyé', description: 'Le devis attend la décision du client.' },
        modification_asked: { label: 'Révision demandée', description: 'Le client attend une version modifiée du devis.' },
        assigned: { label: 'Chantier confirmé', description: 'Le contrat est accepté. Le chantier peut commencer.' },
        completion_pending: { label: 'Confirmation client attendue', description: 'Vous avez déclaré la fin des travaux. Le client doit confirmer ou signaler un problème.' },
        completion_disputed: { label: 'Problème signalé', description: 'Échangez avec le client et résolvez le problème avant le paiement du solde.' },
        finished: { label: 'Travaux confirmés', description: 'Le règlement du chantier est maintenant attendu.' },
        paid: { label: 'Paiement reçu', description: 'Le client peut maintenant publier son avis.' },
        reviewed: { label: 'Projet clôturé', description: 'Le projet est terminé, payé et évalué.' },
      },
      offers: {
        eyebrow: 'Avant attribution',
        title: 'Mes propositions envoyées',
        pending: 'En attente',
        accepted: 'Acceptées',
        declined: 'Non retenues',
        pendingLower: 'en attente',
        acceptedLower: 'acceptées',
        declinedLower: 'non retenues',
        loading: 'Chargement de vos propositions…',
        emptyTitle: 'Aucune proposition dans cette catégorie',
        emptyBody: 'Les propositions envoyées depuis Explorer apparaîtront ici.',
        locationMissing: 'Localisation non renseignée',
        proposedVisit: 'Visite proposée',
        estimatedBudget: 'Budget estimatif',
        budgetHint: 'Indicatif, modifiable après visite',
        becameJob: 'Cette proposition est devenue une mission.',
        loadError: 'Impossible de charger vos propositions.',
        projectWithoutDescription: 'Projet sans description',
        all: 'Toutes',
        edit: 'Modifier',
        withdraw: 'Retirer',
        withdrawing: 'Retrait…',
        projectAlt: 'Projet : {{description}}',
      },
    },
    profileSidebar: {
      profileOf: 'Profil de {{name}}',
      changePhoto: 'Changer la photo',
      photoUpdated: 'Votre photo de profil a été mise à jour.',
      photoError: 'La photo n’a pas pu être enregistrée.',
      uploading: 'Envoi de la photo · {{progress}} %',
      averageRating: 'Note moyenne',
      noRating: 'Pas encore d’évaluation',
      manageProfile: 'Gérer mon profil',
      speciality: 'Spécialité',
      region: 'Région',
      status: 'Statut',
    },
    specialities: {
      window: 'Menuiserie',
      electricity: 'Électricité',
      plumbing: 'Plomberie',
      painting: 'Peinture',
      masonry: 'Maçonnerie',
      roofing: 'Couverture',
      heating: 'Chauffage',
      renovation: 'Rénovation',
      general: 'Travaux',
    },
    artisanStatus: {
      approved: 'Profil validé',
      rejected: 'Validation refusée',
      suspended: 'Profil suspendu',
      pending: 'Validation en cours',
    },
    trust: {
      expert: 'LPB Expert',
      veryReliable: 'Très fiable',
      verifiedProfile: 'Profil vérifié',
      progressing: 'En progression',
      newOnLpb: 'Nouveau sur LPB',
      excellent: 'Excellent',
      veryGood: 'Très bon',
      good: 'Bon',
      developing: 'À développer',
      new: 'Nouveau',
      verifiedJobs: 'projets vérifiés',
      reliablePayments: 'paiements fiables',
      responsiveness: 'réactivité',
      punctuality: 'ponctualité',
      toMeasure: 'à mesurer',
      understandScore: 'Comprendre ce score',
      explanationTitle: 'Comment lire ces indicateurs ?',
      explanationBase: 'Le score repose uniquement sur des projets et avis vérifiés. La réactivité mesure des délais de réponse observables sur les propositions et les échanges du projet.',
      explanationClient: 'La fiabilité de paiement tient compte des paiements confirmés et des évaluations vérifiées laissées par les artisans.',
      explanationArtisan: 'La ponctualité compare la fin déclarée avec la durée contractuelle. Lorsque l’acompte arrive après la date prévue, le délai réel du chantier est décalé pour ne pas pénaliser l’artisan.',
      explanationWeights: 'Les pondérations exactes restent confidentielles afin de limiter les manipulations du système.',
      missingMetrics: 'Les indicateurs non encore mesurés apparaissent avec « — » et ne sont pas inventés.',
      reputationTitle: 'Ma réputation sur Le Petit Boulot',
      reputationSubtitle: 'Seuls les projets payés, les délais observables et les avis vérifiés sont pris en compte.',
      latestReviews: 'Mes derniers avis publics',
      verifiedReviews: 'Avis vérifiés',
      reviewCount: '{{count}} avis',
      reviewLoading: 'Chargement des avis…',
      reviewError: 'Les avis ne peuvent pas être chargés pour le moment.',
      reviewEmpty: 'Aucun avis public pour le moment.',
      verifiedClient: 'Client vérifié',
      verifiedProfessional: 'Artisan vérifié',
      verifiedProject: 'Projet vérifié',
    },
    rankings: {
      bestTitle: 'Les artisans les mieux notés',
      bestSubtitle: 'Selon les avis vérifiés des clients',
      activeTitle: 'Les artisans les plus actifs',
      activeSubtitle: 'Selon le nombre de projets terminés',
      empty: 'Le classement sera disponible après les premières interventions évaluées.',
      profileAlt: 'Profil de {{name}}',
      professionalAlt: 'Profil artisan',
      jobs: '{{count}} projet(s)',
    },
    carousel: {
      artisanPhoto: 'Photo artisan',
      clientPhoto: 'Photo client',
      before: 'Avant',
      after: 'Après',
      during: 'Pendant',
      detail: 'Détail',
      defaultAlt: 'Photo du chantier',
      regionLabel: 'Photos de la demande',
      roleDescription: 'carrousel',
      imageAlt: '{{alt}} — photo {{index}} sur {{total}}',
      photoCount: '{{count}} photo(s)',
      noPhoto: 'Aucune photo',
      previous: 'Afficher la photo précédente',
      next: 'Afficher la photo suivante',
      swipe: 'Faites glisser pour voir les autres photos',
      choose: 'Choisir une photo',
      show: 'Afficher la photo {{index}}',
    },
    location: {
      unspecified: 'Localisation à préciser',
      arrivalSuccess: 'Arrivée confirmée. Votre position précise n’a pas été enregistrée.',
      arrivalError: 'Impossible de confirmer votre arrivée.',
      checking: 'Vérification…',
      arrived: 'Je suis arrivé',
      arrivalConfirmed: 'Arrivée confirmée',
      privacy: 'L’adresse exacte devient accessible après acceptation de la proposition de visite.',
      noRoute: 'Aucune visite ou mission navigable à planifier.',
      routeError: 'Impossible de préparer cet itinéraire.',
      preparing: 'Préparation…',
      planVisits: 'Planifier mes visites',
      jobAddress: 'Adresse du chantier',
      jobArea: 'Zone du chantier',
      farFromJob: 'Vous êtes encore à environ {{distance}} du chantier. Rapprochez-vous avant de confirmer.',
      exactNotAccessible: 'Les adresses exactes de ces missions ne sont pas encore accessibles.',
      itinerary: 'Itinéraire',
      chooseApp: 'Choisissez votre application',
      navigationTraffic: 'Navigation et trafic',
      appleDevices: 'iPhone, iPad et Mac',
      communityNavigation: 'Navigation communautaire',
      webAlternative: 'Alternative web',
      copied: 'Adresse copiée',
      copyAddress: 'Copier l’adresse',
      unavailable: 'Itinéraire indisponible',
      openItinerary: 'Ouvrir l’itinéraire',
    },
    conversation: {
      loadError: 'Impossible de charger les échanges.',
      photoError: 'Une photo ne peut pas être ajoutée.',
      sendError: 'Votre message n’a pas pu être envoyé.',
      title: 'Échanges du projet',
      subtitle: 'Messages, photos et décisions restent réunis au même endroit.',
      empty: 'Commencez ici pour préciser un détail, partager une photo ou confirmer un rendez-vous.',
      showPhoto: 'Afficher la photo {{index}} dans la galerie',
      previewAlt: 'Aperçu',
      removePhoto: 'Retirer la photo',
      placeholder: 'Écrivez un message…',
      addPhotos: 'Ajouter des photos',
      photos: 'Photos',
      gallery: 'Galerie des photos du projet',
      saveShare: 'Enregistrer / partager',
      openImage: 'Ouvrir l’image',
      closeGallery: 'Fermer la galerie',
      previousPhoto: 'Photo précédente',
      nextPhoto: 'Photo suivante',
      maxPhotos: 'Vous pouvez envoyer au maximum 4 photos par message.',
      you: 'Vous',
      participant: 'Participant',
      sentAt: 'Envoi…',
      addUpToFour: 'Ajouter jusqu’à 4 photos',
      sharedBy: 'Photo partagée par {{name}}',
      position: '{{index}} sur {{total}}',
      directSaveError: 'Impossible d’enregistrer directement cette photo. Touchez « Ouvrir l’image », puis utilisez Partager ou maintenez votre doigt sur la photo.',
    },
    estimationForm: {
      editEyebrow: 'Modifier la proposition',
      newEyebrow: 'Nouvelle proposition',
      editTitle: 'Mettre à jour votre proposition',
      newTitle: 'Choisir la meilleure première étape',
      subtitle: 'Indiquez clairement au client si vous pouvez chiffrer à distance, si une visite est nécessaire ou si quelques informations supplémentaires suffisent.',
      identityHint: 'Cette identité sera visible par le client.',
      assessmentQuestion: 'Comment souhaitez-vous évaluer le chantier ?',
      assessmentAria: 'Méthode d’évaluation',
      directTitle: 'Devis possible à distance',
      directDescription: 'Les photos et informations suffisent pour préparer un devis sans visite préalable.',
      visitTitle: 'Visite nécessaire',
      visitDescription: 'Une visite sur place est indispensable avant de chiffrer précisément les travaux.',
      infoTitle: 'Informations complémentaires',
      infoDescription: 'Demandez des photos, mesures ou précisions avant de décider si une visite est utile.',
      messageLabel: 'Votre message au client',
      messagePlaceholder: 'Expliquez votre première analyse, vos disponibilités et la prochaine étape proposée.',
      infoLabel: 'Informations nécessaires',
      infoPlaceholder: 'Ex. photo du tableau électrique, dimensions de la fenêtre, courte vidéo de la fuite…',
      phone: 'Téléphone',
      visitDate: 'Date de visite proposée',
      budget: 'Budget estimatif',
      required: 'requis',
      optional: 'optionnel',
      directBudgetHint: 'Ce montant aide le client à décider avant de recevoir le devis détaillé.',
      budgetHint: 'Montant indicatif, modifiable avant l’envoi du devis définitif.',
      approvalWarning: 'Votre profil est encore en cours de validation. Vous pouvez préparer votre réponse, mais l’envoi sera disponible uniquement après validation.',
      notice: 'Cette proposition n’est pas encore un contrat. Le devis final restera modifiable et devra être accepté par le client avant tout paiement.',
      sessionMissing: 'La session ou la demande est introuvable.',
      approvalRequired: 'Votre profil doit être validé avant l’envoi d’une proposition.',
      messageTooShort: 'Présentez votre proposition en au moins 10 caractères.',
      phoneRequired: 'Renseignez un numéro de téléphone.',
      visitRequired: 'Proposez une date de visite.',
      budgetRequired: 'Ajoutez un budget estimatif pour une proposition sans visite.',
      infoRequired: 'Précisez les informations dont vous avez besoin.',
      saveChanges: 'Enregistrer les modifications',
      sendProposal: 'Envoyer la proposition',
    },
    quoteRevision: {
      minResponse: 'Répondez au client en au moins 10 caractères.',
      requiredFields: 'Renseignez le téléphone, la date de début et la durée estimée.',
      taxRequired: 'Choisissez le régime de TVA applicable.',
      invalidAmounts: 'Les montants doivent être valides et positifs ou nuls.',
      eyebrow: 'Révision demandée',
      title: 'Mettre à jour le contrat',
      subtitle: 'Répondez précisément, puis vérifiez le planning et les montants avant l’envoi.',
      missing: 'Le contrat n’est plus disponible.',
      clientRequest: 'Demande du client',
      noDetails: 'Aucun détail fourni.',
      response: 'Votre réponse',
      responsePlaceholder: 'Expliquez les changements appliqués ou les éléments qui restent inchangés.',
      phone: 'Téléphone',
      startDate: 'Date de début',
      duration: 'Durée estimée',
      validity: 'Validité du devis (jours)',
      materials: 'Matériaux HT',
      labour: 'Main-d’œuvre HT',
      travel: 'Déplacement HT',
      vat: 'Régime de TVA',
      choose: 'Choisir',
      newTotal: 'Nouveau total TTC',
      resend: 'Renvoyer le devis',
      sessionMissing: 'Le devis ou la session est introuvable.',
      taxExempt: 'TVA non applicable — art. 293 B',
      vatRate: 'TVA {{rate}} %',
    },
    finalising: {
      confirmRequired: 'Confirmez que les travaux prévus au contrat sont terminés.',
      eyebrow: 'Fin de chantier',
      title: 'Déclarer les travaux terminés',
      subtitle: 'Cette action informera le client que le paiement peut être effectué.',
      missing: 'Le contrat n’est plus disponible.',
      client: 'Client',
      amount: 'Montant du contrat',
      extra: 'Informations complémentaires',
      placeholder: 'Ex. recommandations d’entretien, élément restant à surveiller ou précision utile au client.',
      notYet: 'Pas encore',
      sessionMissing: 'Le devis ou la session est introuvable.',
      confirmation: 'Je confirme que les prestations prévues au devis sont terminées et que le montant affiché est exact.',
      warning: 'Après validation, le projet passera au statut « travaux terminés » et le client pourra confirmer les travaux puis régler le solde.',
      confirming: 'Validation…',
      confirm: 'Confirmer la fin du chantier',
    },
    withdraw: {
      eyebrow: 'Retirer une proposition',
      title: 'Confirmer le retrait',
      warning: 'Le client ne verra plus votre proposition.',
      keep: 'Conserver ma proposition',
      withdrawing: 'Retrait…',
      confirm: 'Retirer définitivement',
      projectDefault: 'Projet',
      detail: 'La demande « {{project}} » redeviendra disponible pour les autres artisans. Les informations de proposition associées seront supprimées.',
    },
    clientReview: {
      verifiedProject: 'Projet vérifié',
      title: 'Évaluer le client',
      overall: 'Expérience globale',
      clarity: 'Clarté de la demande',
      clarityHint: 'Informations suffisantes et décisions compréhensibles.',
      responsiveness: 'Réactivité',
      responsivenessHint: 'Délais de réponse pendant la proposition et le chantier.',
      payment: 'Fiabilité du paiement',
      paymentHint: 'Respect des étapes d’acompte et de règlement du solde.',
      optionalComment: 'Commentaire facultatif',
      notice: 'Les avis sont publiés simultanément ou à la fin du délai prévu afin de limiter les représailles.',
      publishing: 'Publication…',
      publish: 'Publier mon avis',
      syncError: 'Cette mission est encore en cours de synchronisation.',
      ratingRequired: 'Choisissez une note globale.',
      publishError: 'Impossible de publier cet avis.',
    },
    planning: {
      eyebrow: 'Votre activité, sans surcharge',
      title: 'Mon planning',
      subtitle: 'Les prochaines actions et échéances utiles, réunies au même endroit.',
      today: "Aujourd’hui",
      week: 'Semaine',
      tasks: 'Tâches',
      addTask: 'Ajouter une tâche',
      openActions: 'actions ouvertes',
      todayAppointments: "rendez-vous aujourd’hui",
      readyProjects: 'chantiers prêts à démarrer',
      overdue: 'en retard',
      noToday: "Rien d’urgent aujourd’hui.",
      noTodayBody: 'Votre prochaine action apparaîtra ici automatiquement.',
      noWeek: 'Aucune échéance planifiée cette semaine.',
      noTasks: 'Aucune tâche ouverte.',
      completed: 'Terminée',
      complete: 'Terminer',
      reopen: 'Rouvrir',
      route: 'Itinéraire',
      openProject: 'Ouvrir le projet',
      paymentReady: 'Acompte reçu · prêt à planifier',
      paymentWaiting: "Acompte en attente · ne démarrez pas encore",
      finalWaiting: 'Solde en attente',
      paid: 'Paiement confirmé',
      conflictTitle: 'Un chevauchement mérite votre attention',
      conflictBody: '{{count}} créneau(x) se chevauchent cette semaine.',
      nearby: '{{count}} interventions proches',
      workload: '{{percent}} % occupé',
      manualTitle: 'Nouvelle tâche',
      taskTitle: 'Intitulé',
      taskTitlePlaceholder: 'Ex. appeler le fournisseur',
      dueDate: 'Échéance',
      startDate: 'Début facultatif',
      endDate: 'Fin facultative',
      priority: 'Priorité',
      low: 'Basse',
      normal: 'Normale',
      high: 'Haute',
      notes: 'Note facultative',
      cancel: 'Annuler',
      save: 'Ajouter',
      saving: 'Ajout…',
      validation: 'Ajoutez au moins un titre et une échéance.',
      saveError: 'La tâche ne peut pas être enregistrée.',
      updateError: 'La tâche ne peut pas être mise à jour.',
      recommended: 'Échéance recommandée',
      auto: 'Créée automatiquement',
      manual: 'Tâche personnelle',
      unscheduled: 'À planifier',
    },
    payments: {
      secureSpace: 'Espace de paiement sécurisé',
      secureProcessing: 'Traitement bancaire sécurisé',
      processingFees: 'Frais de traitement bancaire',
      estimatedProcessing: 'Traitement bancaire estimé',
      estimatedNet: 'Net estimé après traitement bancaire',
      providerDisclosure: 'Le prestataire de paiement conserve vos données bancaires sensibles. Le Petit Boulot ne voit jamais votre IBAN complet.',
      accountReady: 'Votre espace de paiement est prêt.',
    },
  },
  en: {
    app: {
      loading: 'Preparing your workspace',
      language: 'Language',
      french: 'Français',
      english: 'English',
    },
    common: {
      close: 'Close',
      cancel: 'Cancel',
      save: 'Save',
      send: 'Send',
      loading: 'Loading…',
      sending: 'Sending…',
      notSpecified: 'Not provided',
      notDefined: 'Not defined',
      client: 'Client',
      professional: 'Professional',
      member: 'Member',
      project: 'Job',
      projects: 'Jobs',
      photo: 'photo',
      photos: 'photos',
      new: 'New',
      view: 'View',
      edit: 'Edit',
      delete: 'Delete',
      previous: 'Previous',
      next: 'Next',
      day: 'day',
      days: 'days',
      all: 'All',
      update: 'Update',
      confirm: 'Confirm',
      validating: 'Confirming…',
      withdrawing: 'Withdrawing…',
      noMessage: 'No message provided.',
      euro: '€',
    },
    nav: {
      clientDemands: 'My requests',
      history: 'History',
      profile: 'My profile',
      logout: 'Log out',
      missions: 'My jobs',
      planning: 'My planner',
      explore: 'Explore',
      showcase: 'My portfolio',
      verifyEmail: 'Verify my email',
      login: 'Log in',
      signup: 'Sign up',
      mobileDemands: 'Requests',
      mobileMissions: 'Jobs',
      mobilePlanning: 'Planner',
      mobileProfile: 'Profile',
    },
    notifications: {
      title: 'Notifications',
      empty: 'You are all caught up.',
      markAll: 'Mark all as read',
      close: 'Close notifications',
      unread: '{{count}} unread',
    },
    jobs: {
      pageTitle: 'Your quotes and jobs',
      workspaceTitle: 'Your work hub',
      workspaceEyebrow: 'Job management',
      workspaceSubtitle: 'Keep useful actions, quotes and active jobs together without losing track.',
      summaryAria: '{{projects}} jobs tracked and {{offers}} proposals pending',
      summaryOffers: 'proposals',
      summaryActions: 'actions',
      summaryActive: 'active',
      summaryFinalize: 'to close',
      planVisits: 'Plan my visits',
      tabsAria: 'Job categories',
      searchPlaceholder: 'Client, job, address…',
      searchAria: 'Search jobs',
      sortAria: 'Sort jobs',
      sortPriority: 'Priority',
      sortNewest: 'Newest first',
      sortOldest: 'Oldest first',
      sortAmount: 'Quote amount',
      noResults: 'No results',
      noTabJobs: 'No jobs in “{{tab}}”',
      tryAnotherKeyword: 'Try another keyword.',
      attention: 'Action required',
      projectBy: 'Job for',
      viewClientProfile: 'View client profile',
      viewScore: 'View score',
      clientProfile: 'client profile',
      verifiedProjects: '{{count}} job(s)',
      noDescription: 'No description provided.',
      progress: 'Job progress',
      step: 'Step {{step}} of 8',
      published: 'Request published',
      visitPlanned: 'Visit scheduled',
      quoteAmount: 'Quote amount',
      clientContact: 'Client contact',
      visitConfirmedWaitingClient: 'Your attendance is confirmed. The client now needs to confirm that the visit took place.',
      visitConfirmInstruction: 'After the visit, confirm your attendance. The client can then confirm it on their side.',
      moreInfoInstruction: 'Use the conversation below to clarify the job. Once you have enough information, start preparing the quote.',
      issuePrefix: 'The client reported an issue:',
      issueFallback: 'review the conversation and agree on a solution.',
      confirmVisit: 'Confirm completed visit',
      infoReady: 'I have the information I need',
      prepareQuote: 'Prepare the quote',
      reviseQuote: 'Revise the quote',
      issueResolved: 'Issue resolved, request confirmation again',
      declareFinished: 'Mark work as completed',
      reviewClient: 'Review the client',
      viewQuote: 'View quote',
      withdrawOffer: 'Withdraw my proposal',
      showMore: 'Show {{count}} more job(s)',
      photoAlt: '{{type}} job photos',
      portfolioPublished: 'Published in portfolio',
      portfolioDraft: 'Draft',
      portfolioHidden: 'Hidden',
      portfolioMissing: 'Not added',
      portfolioAdd: 'Add to my portfolio',
      portfolioEdit: 'Edit portfolio entry',
      completedProject: 'Completed job',
      viewReview: 'View review',
      viewFile: 'View job file',
      archiveAlt: '{{title}} job',
      tabOffers: 'Proposals',
      tabOffersDescription: 'Proposals sent before the client selects a professional.',
      tabAction: 'Needs action',
      tabActionDescription: 'Jobs waiting for an action from you.',
      tabActive: 'Active',
      tabActiveDescription: 'Your proposals, sent quotes and active jobs.',
      tabFinalize: 'To close',
      tabFinalizeDescription: 'Jobs awaiting payment or a client review.',
      tabCompleted: 'Completed',
      tabCompletedDescription: 'Past jobs available for your portfolio.',
      status: {
        estimation_wait: { label: 'Proposal sent', description: 'The client is reviewing your visit proposal.' },
        estimation_confirmed: { label: 'Visit accepted', description: 'Contact the client and prepare the visit.' },
        estimation_visit_valid: { label: 'Quote to prepare', description: 'The assessment is complete. The client is waiting for your detailed quote.' },
        contract_offered: { label: 'Quote sent', description: 'The quote is awaiting the client’s decision.' },
        modification_asked: { label: 'Revision requested', description: 'The client is waiting for an updated quote.' },
        assigned: { label: 'Job confirmed', description: 'The quote has been accepted. The job can begin once the deposit is confirmed.' },
        completion_pending: { label: 'Client confirmation pending', description: 'You marked the work as completed. The client must confirm it or report an issue.' },
        completion_disputed: { label: 'Issue reported', description: 'Resolve the issue with the client before the final payment.' },
        finished: { label: 'Work confirmed', description: 'The final payment is now pending.' },
        paid: { label: 'Payment received', description: 'The client can now leave a verified review.' },
        reviewed: { label: 'Job closed', description: 'The job is completed, paid and reviewed.' },
      },
      offers: {
        eyebrow: 'Before selection',
        title: 'My sent proposals',
        pending: 'Pending',
        accepted: 'Accepted',
        declined: 'Not selected',
        pendingLower: 'pending',
        acceptedLower: 'accepted',
        declinedLower: 'not selected',
        loading: 'Loading your proposals…',
        emptyTitle: 'No proposals in this category',
        emptyBody: 'Proposals sent from Explore will appear here.',
        locationMissing: 'Location not provided',
        proposedVisit: 'Proposed visit',
        estimatedBudget: 'Estimated budget',
        budgetHint: 'Indicative and editable after the visit',
        becameJob: 'This proposal has become an active job.',
        loadError: 'Your proposals could not be loaded.',
        projectWithoutDescription: 'Job without a description',
        all: 'All',
        edit: 'Edit',
        withdraw: 'Withdraw',
        withdrawing: 'Withdrawing…',
        projectAlt: 'Job: {{description}}',
      },
    },
    profileSidebar: {
      profileOf: '{{name}} profile',
      changePhoto: 'Change photo',
      photoUpdated: 'Your profile photo has been updated.',
      photoError: 'The photo could not be saved.',
      uploading: 'Uploading photo · {{progress}}%',
      averageRating: 'Average rating',
      noRating: 'No rating yet',
      manageProfile: 'Manage my profile',
      speciality: 'Trade',
      region: 'Region',
      status: 'Status',
    },
    specialities: {
      window: 'Joinery & windows',
      electricity: 'Electrical work',
      plumbing: 'Plumbing',
      painting: 'Painting',
      masonry: 'Masonry',
      roofing: 'Roofing',
      heating: 'Heating',
      renovation: 'Renovation',
      general: 'General work',
    },
    artisanStatus: {
      approved: 'Verified profile',
      rejected: 'Verification declined',
      suspended: 'Profile suspended',
      pending: 'Verification in progress',
    },
    trust: {
      expert: 'LPB Expert',
      veryReliable: 'Highly reliable',
      verifiedProfile: 'Verified profile',
      progressing: 'Building history',
      newOnLpb: 'New to LPB',
      excellent: 'Excellent',
      veryGood: 'Very good',
      good: 'Good',
      developing: 'Developing',
      new: 'New',
      verifiedJobs: 'verified jobs',
      reliablePayments: 'reliable payments',
      responsiveness: 'responsiveness',
      punctuality: 'on-time delivery',
      toMeasure: 'not measured yet',
      understandScore: 'Understand this score',
      explanationTitle: 'How are these indicators calculated?',
      explanationBase: 'The score only uses verified jobs and reviews. Responsiveness is based on observable reply times in proposals and project conversations.',
      explanationClient: 'Payment reliability uses confirmed payments and verified reviews left by professionals.',
      explanationArtisan: 'On-time delivery compares the declared completion date with the contractual duration. If the deposit arrives late, the effective schedule is shifted so the professional is not unfairly penalised.',
      explanationWeights: 'The exact weightings remain confidential to reduce attempts to manipulate the system.',
      missingMetrics: 'Indicators that have not yet been measured are shown as “—”; no value is invented.',
      reputationTitle: 'My reputation on Le Petit Boulot',
      reputationSubtitle: 'Only paid jobs, observable timings and verified reviews are included.',
      latestReviews: 'My latest public reviews',
      verifiedReviews: 'Verified reviews',
      reviewCount: '{{count}} review(s)',
      reviewLoading: 'Loading reviews…',
      reviewError: 'Reviews cannot be loaded right now.',
      reviewEmpty: 'No public reviews yet.',
      verifiedClient: 'Verified client',
      verifiedProfessional: 'Verified professional',
      verifiedProject: 'Verified job',
    },
    rankings: {
      bestTitle: 'Top-rated professionals',
      bestSubtitle: 'Based on verified client reviews',
      activeTitle: 'Most active professionals',
      activeSubtitle: 'Based on completed jobs',
      empty: 'Rankings will appear after the first reviewed jobs.',
      profileAlt: '{{name}} profile',
      professionalAlt: 'Professional profile',
      jobs: '{{count}} job(s)',
    },
    carousel: {
      artisanPhoto: 'Professional photo',
      clientPhoto: 'Client photo',
      before: 'Before',
      after: 'After',
      during: 'During',
      detail: 'Detail',
      defaultAlt: 'Job photo',
      regionLabel: 'Request photos',
      roleDescription: 'carousel',
      imageAlt: '{{alt}} — photo {{index}} of {{total}}',
      photoCount: '{{count}} photo(s)',
      noPhoto: 'No photos',
      previous: 'Show previous photo',
      next: 'Show next photo',
      swipe: 'Swipe to view more photos',
      choose: 'Choose a photo',
      show: 'Show photo {{index}}',
    },
    location: {
      unspecified: 'Location to be confirmed',
      arrivalSuccess: 'Arrival confirmed. Your precise position was not stored.',
      arrivalError: 'Your arrival could not be confirmed.',
      checking: 'Checking…',
      arrived: 'I have arrived',
      arrivalConfirmed: 'Arrival confirmed',
      privacy: 'The exact address becomes available after the visit proposal is accepted.',
      noRoute: 'There are no navigable visits or jobs to plan.',
      routeError: 'The route could not be prepared.',
      preparing: 'Preparing…',
      planVisits: 'Plan my visits',
      jobAddress: 'Job address',
      jobArea: 'Job area',
      farFromJob: 'You are still about {{distance}} from the job. Move closer before confirming your arrival.',
      exactNotAccessible: 'The exact addresses for these jobs are not available yet.',
      itinerary: 'Directions',
      chooseApp: 'Choose your navigation app',
      navigationTraffic: 'Directions and traffic',
      appleDevices: 'iPhone, iPad and Mac',
      communityNavigation: 'Community navigation',
      webAlternative: 'Web alternative',
      copied: 'Address copied',
      copyAddress: 'Copy address',
      unavailable: 'Directions unavailable',
      openItinerary: 'Open directions',
    },
    conversation: {
      loadError: 'The conversation could not be loaded.',
      photoError: 'A photo could not be added.',
      sendError: 'Your message could not be sent.',
      title: 'Job conversation',
      subtitle: 'Messages, photos and decisions stay together in one place.',
      empty: 'Start here to clarify a detail, share a photo or confirm an appointment.',
      showPhoto: 'Show photo {{index}} in the gallery',
      previewAlt: 'Preview',
      removePhoto: 'Remove photo',
      placeholder: 'Write a message…',
      addPhotos: 'Add photos',
      photos: 'Photos',
      gallery: 'Job photo gallery',
      saveShare: 'Save / share',
      openImage: 'Open image',
      closeGallery: 'Close gallery',
      previousPhoto: 'Previous photo',
      nextPhoto: 'Next photo',
      maxPhotos: 'You can send up to 4 photos per message.',
      you: 'You',
      participant: 'Participant',
      sentAt: 'Sending…',
      addUpToFour: 'Add up to 4 photos',
      sharedBy: 'Photo shared by {{name}}',
      position: '{{index}} of {{total}}',
      directSaveError: 'This photo could not be saved directly. Select “Open image”, then use Share or press and hold the photo.',
    },
    estimationForm: {
      editEyebrow: 'Edit proposal',
      newEyebrow: 'New proposal',
      editTitle: 'Update your proposal',
      newTitle: 'Choose the best first step',
      subtitle: 'Tell the client whether you can quote remotely, need a site visit or only need a few more details.',
      identityHint: 'The client will see this identity.',
      assessmentQuestion: 'How would you like to assess the job?',
      assessmentAria: 'Assessment method',
      directTitle: 'Remote quote possible',
      directDescription: 'The photos and information are sufficient to prepare a quote without a prior visit.',
      visitTitle: 'Site visit required',
      visitDescription: 'An on-site visit is necessary before pricing the work accurately.',
      infoTitle: 'More information needed',
      infoDescription: 'Request photos, measurements or details before deciding whether a visit is useful.',
      messageLabel: 'Your message to the client',
      messagePlaceholder: 'Explain your initial assessment, availability and proposed next step.',
      infoLabel: 'Information needed',
      infoPlaceholder: 'e.g. a photo of the electrical panel, window dimensions or a short video of the leak…',
      phone: 'Phone',
      visitDate: 'Proposed visit date',
      budget: 'Estimated budget',
      required: 'required',
      optional: 'optional',
      directBudgetHint: 'This amount helps the client decide before receiving the detailed quote.',
      budgetHint: 'Indicative amount that can be changed before the final quote is sent.',
      approvalWarning: 'Your profile is still being reviewed. You can prepare your response, but you can only send it after approval.',
      notice: 'This proposal is not a contract. The final quote can still be revised and must be accepted by the client before payment.',
      sessionMissing: 'The session or request could not be found.',
      approvalRequired: 'Your profile must be approved before you can send a proposal.',
      messageTooShort: 'Describe your proposal using at least 10 characters.',
      phoneRequired: 'Provide a phone number.',
      visitRequired: 'Propose a visit date.',
      budgetRequired: 'Add an estimated budget for a remote proposal.',
      infoRequired: 'Explain what information you need.',
      saveChanges: 'Save changes',
      sendProposal: 'Send proposal',
    },
    quoteRevision: {
      minResponse: 'Reply to the client using at least 10 characters.',
      requiredFields: 'Provide a phone number, start date and estimated duration.',
      taxRequired: 'Select the VAT treatment for this quote.',
      invalidAmounts: 'Amounts must be valid and zero or greater.',
      eyebrow: 'Revision requested',
      title: 'Update the quote',
      subtitle: 'Answer clearly, then check the schedule and amounts before sending.',
      missing: 'The quote is no longer available.',
      clientRequest: 'Client request',
      noDetails: 'No details provided.',
      response: 'Your response',
      responsePlaceholder: 'Explain the changes you made and anything that remains unchanged.',
      phone: 'Phone',
      startDate: 'Start date',
      duration: 'Estimated duration',
      validity: 'Quote validity (days)',
      materials: 'Materials excl. VAT',
      labour: 'Labour excl. VAT',
      travel: 'Travel excl. VAT',
      vat: 'VAT treatment',
      choose: 'Select',
      newTotal: 'New total incl. VAT',
      resend: 'Send revised quote',
      sessionMissing: 'The quote or your session could not be found.',
      taxExempt: 'VAT not applicable — French Tax Code art. 293 B',
      vatRate: 'VAT {{rate}}%',
    },
    finalising: {
      confirmRequired: 'Confirm that the work included in the quote has been completed.',
      eyebrow: 'Job completion',
      title: 'Mark work as completed',
      subtitle: 'The client will be notified that the job is ready for confirmation and final payment.',
      missing: 'The quote is no longer available.',
      client: 'Client',
      amount: 'Quote amount',
      extra: 'Additional information',
      placeholder: 'e.g. care instructions, an item to monitor or useful information for the client.',
      notYet: 'Not yet',
      sessionMissing: 'The quote or your session could not be found.',
      confirmation: 'I confirm that the work included in the quote is complete and that the displayed amount is correct.',
      warning: 'After confirmation, the job will be marked as completed. The client can then approve the work and pay the balance.',
      confirming: 'Confirming…',
      confirm: 'Confirm job completion',
    },
    withdraw: {
      eyebrow: 'Withdraw a proposal',
      title: 'Confirm withdrawal',
      warning: 'The client will no longer see your proposal.',
      keep: 'Keep my proposal',
      withdrawing: 'Withdrawing…',
      confirm: 'Withdraw permanently',
      projectDefault: 'Job',
      detail: 'The request “{{project}}” will become available to other professionals again. The related proposal information will be removed.',
    },
    clientReview: {
      verifiedProject: 'Verified job',
      title: 'Review the client',
      overall: 'Overall experience',
      clarity: 'Request clarity',
      clarityHint: 'Sufficient information and clear decisions.',
      responsiveness: 'Responsiveness',
      responsivenessHint: 'Reply times during the proposal and the job.',
      payment: 'Payment reliability',
      paymentHint: 'Compliance with the deposit and final-payment stages.',
      optionalComment: 'Optional comment',
      notice: 'Reviews are published together, or after the confidentiality period, to reduce retaliatory reviews.',
      publishing: 'Publishing…',
      publish: 'Publish my review',
      syncError: 'This job is still being synchronised.',
      ratingRequired: 'Choose an overall rating.',
      publishError: 'This review could not be published.',
    },
    planning: {
      eyebrow: 'Your business, without the clutter',
      title: 'My planner',
      subtitle: 'The next useful actions and deadlines, gathered in one calm workspace.',
      today: 'Today',
      week: 'Week',
      tasks: 'Tasks',
      addTask: 'Add a task',
      openActions: 'open actions',
      todayAppointments: 'appointments today',
      readyProjects: 'jobs ready to start',
      overdue: 'overdue',
      noToday: 'Nothing urgent today.',
      noTodayBody: 'Your next action will appear here automatically.',
      noWeek: 'No deadline scheduled this week.',
      noTasks: 'No open tasks.',
      completed: 'Completed',
      complete: 'Complete',
      reopen: 'Reopen',
      route: 'Directions',
      openProject: 'Open project',
      paymentReady: 'Deposit received · ready to schedule',
      paymentWaiting: 'Deposit pending · do not start yet',
      finalWaiting: 'Final payment pending',
      paid: 'Payment confirmed',
      conflictTitle: 'A scheduling overlap needs your attention',
      conflictBody: '{{count}} time slot(s) overlap this week.',
      nearby: '{{count}} nearby jobs',
      workload: '{{percent}}% booked',
      manualTitle: 'New task',
      taskTitle: 'Title',
      taskTitlePlaceholder: 'e.g. call the supplier',
      dueDate: 'Due date',
      startDate: 'Optional start',
      endDate: 'Optional end',
      priority: 'Priority',
      low: 'Low',
      normal: 'Normal',
      high: 'High',
      notes: 'Optional note',
      cancel: 'Cancel',
      save: 'Add',
      saving: 'Adding…',
      validation: 'Add at least a title and a due date.',
      saveError: 'The task could not be saved.',
      updateError: 'The task could not be updated.',
      recommended: 'Recommended deadline',
      auto: 'Created automatically',
      manual: 'Personal task',
      unscheduled: 'To schedule',
    },
    payments: {
      secureSpace: 'Secure payment space',
      secureProcessing: 'Secure bank processing',
      processingFees: 'Bank processing fees',
      estimatedProcessing: 'Estimated bank processing',
      estimatedNet: 'Estimated net after bank processing',
      providerDisclosure: 'The payment provider securely stores sensitive banking details. Le Petit Boulot never sees your full IBAN.',
      accountReady: 'Your payment space is ready.',
    },
  },
};

export const interpolate = (template, variables = {}) => String(template || '').replace(
  /{{\s*([^}]+)\s*}}/g,
  (_, key) => (variables[key.trim()] === undefined ? '' : String(variables[key.trim()])),
);
